import { useState, useEffect } from 'react';
import { getCurrentWeekDates } from '../../../../../lib/date';
import { CheckCircleIcon as CheckCircleIconOutline } from '@heroicons/react/24/outline';
import { CheckCircleIcon as CheckCircleIconSolid } from '@heroicons/react/20/solid';
import request from '../../../../../lib/request';

const dayName = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];

const MyRoutine = ({ handleHubChange }) => {
  const [currentWeek, setCurrentWeek] = useState([]);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const currentWeekDates = getCurrentWeekDates(new Date());
    setCurrentWeek(currentWeekDates);
    getProgramRoutineLog(
      currentWeekDates[0],
      currentWeekDates[currentWeekDates.length - 1]
    );
  }, []);

  const getProgramRoutineLog = async (startDate, endDate) => {
    try {
      const { result } = await request.get(
        `/workout/program/routine/log?startDate=${startDate}&endDate=${endDate}`
      );

      if (result) {
        setLogs(result.map((item) => item.logDate));
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <button
      className='bg-secondary rounded-xl p-4'
      onClick={() => handleHubChange('ROUTINE')}
    >
      <div className='flex items-center gap-4 mb-4'>
        <h2 className='text-lg font-semibold'>My Routine</h2>
      </div>
      <p className='text-sm text-gray-400 mb-4 text-left'>
        View your workout plan
      </p>
      <div className='grid grid-cols-7 gap-1'>
        {currentWeek.map((date, i) => (
          <div
            key={i}
            className='flex flex-col items-center justify-center'
          >
            <div className='text-[10px] text-gray-400'>{dayName[i]}</div>
            {logs.includes(date) ? (
              <CheckCircleIconSolid className='size-4 text-accent' />
            ) : (
              <CheckCircleIconOutline className='size-4 text-white/50' />
            )}
          </div>
        ))}
      </div>
    </button>
  );
};

export default MyRoutine;
